export const TITLE = 'Geospatial experts mapping business needs with actionable intelligence';
export const CONTENT =
  'Action Engine is an end to end software solutions company. With a strong core of geo data engineers, analytics and visualization experts and designers we bring a full set of capabilities to your next project.';
export const SCROLL_TEXT = 'scroll to find out more';
